import { defineMessages } from "react-intl";

export const messages = defineMessages({
  genericErrorDescription: {
    id: "root.error.generic.description",
    defaultMessage: "Please try again later.",
    description: "Description shown by the root fallback error boundary for generic errors.",
  },
  genericErrorTitle: {
    id: "root.error.generic.title",
    defaultMessage: "Uh oh. Something went wrong.",
    description: "Title shown by the root fallback error boundary for generic errors.",
  },
  reloadPageAction: {
    id: "root.error.reload_page",
    defaultMessage: "Reload page",
    description: "Action shown by the root fallback error boundary to reload the page.",
  },
  serviceUnavailableDescription: {
    id: "root.error.service_unavailable.description",
    defaultMessage: "Ads Manager is temporarily unavailable. Please try again in a few minutes.",
    description: "Description shown by the root fallback error boundary for service outages.",
  },
  serviceUnavailableTitle: {
    id: "root.error.service_unavailable.title",
    defaultMessage: "Service temporarily unavailable",
    description: "Title shown by the root fallback error boundary for service outages.",
  },
});
